import styled, { css } from "styled-components";

export default styled.input`
  ${({ theme }) => css`
    color: ${theme.colors.fg};
    border: ${theme.colors.midGrey} 2px solid;

    &:hover,
    &:focus,
    &:active {
      border-color: ${theme.colors.fg};
    }

    &::placeholder {
      color: ${theme.colors.fg};
    }

    background: transparent;
    font-size: 1rem;
    box-sizing: border-box;
    padding: 0.7rem 0.8em;
    transition: all ease-in-out 0.2s;
    outline: none;
    width: 100%;

    ::placeholder {
      /* Chrome, Firefox, Opera, Safari 10.1+ */
      color: ${theme.colors.neutral};
    }

    .error {
      border-color: ${theme.colors.darkRed};
    }
  `}

  &:disabled {
    opacity: 0.5;
  }
`;
